module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-41.06d437b1.svg";